import React, { useState, useEffect } from "react";
import styles from "./OurClients.module.css";
import shortarrow from "../../../images/Brands/arrow.svg";
import Spinner from "../../Spinner/Spinner";

function OurClients() {
  const [companyLogos, setCompanyLogos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getData = async () => {
    if (isLoading) return;
    try {
      setIsLoading(true);
      const data = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/companyPageList?page=1&limit=200`
      );
      const json = await data.json();

      setCompanyLogos(json.clients || []);
    } catch (e) {
      console.error("Failed to load company logos", e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
        <Spinner />
    );
  }

  return (
    <>
      <div className={styles.companies}>
        <div className={styles.changer}>
          <div className={styles.shortarrow}>
            <img src={shortarrow} alt="" />
          </div>
          <div className={styles.text}>
            <p>the absolute best</p>
          </div>
        </div>
        <h1>
          We work with the <span>Best</span>
        </h1>
        <div className={styles.structure}>
          {companyLogos.map((c, i) => {
            return (
              <div className={styles.brandimages} key={c._id}>
                <img
                  src={c.logo_url}
                  alt="Logo"
                  className={styles.brandlogos}
                />
              </div>
            );
          })}
          {isLoading && (
            <div className={styles.brandimages}>
              <div className={styles.brandlogos} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default OurClients;
